<template>
  <div class="action-container">
    <bimContainer>
      <div class="action-time">
        <bim-text class="w-100 text-center action-time__title" type="h3" bold>{{ $t("Сделай свою программу удобнее!") }}</bim-text>
        <bim-text class="w-100 text-center action-time__text mx-auto" type="accent">{{ $t("Установка плагина занимает МИНУТУ, а вы экономите ЧАСЫ поиска и импорта нужного семейства в проект.") }}</bim-text>
        <div class="mt-9 mb-12 w-100">
          <a href="/plugindownload/autodesk/" target="_blank" class="d-block" @click="logDownloadPluginBIMLIBCAD">
            <bim-button class="d-block mx-auto action-time__button-download" :label="$t('Скачать плагин')" size="l" />
          </a>
        </div>
        <div class="d-flex w-100 action-time__form-wrapper">
          <form class="action-time__form mx-auto p-9 block-form">
            <div class="block-form__wrapper">
              <bim-text class="w-100 mb-9 text-center" type="accent" bold>{{ $t("Подробности у наших специалистов.") }}<br>{{ $t("Это живые люди с большим опытом.") }}</bim-text>

              <div class="d-flex mb-9 flex-column flex-sm-row">
                <bim-input
                  class="mr-sm-9 mb-9 mb-sm-0 flex-grow-1"
                  :placeholder="$t('Имя') + '*'"
                  v-model="form.name"
                  formKey="form.name"
                  :formModel="_self"
                />

                <bim-input
                  class="flex-grow-1"
                  :placeholder="$t('Телефон') + '*'"
                  v-model="form.phone"
                  formKey="form.phone"
                  mask="phone"
                  :formModel="_self"
                />
              </div>

              <bim-textarea
                :placeholder="$t('Суть обращения')"
                class="w-100 block-form__textarea mb-9"
                v-model="form.desc"
                formKey="form.desc"
                :formModel="_self"
              />

              <bim-button @click.prevent="sendForm" :disabled="sending" outline color="primary" :label="$t('Отправить заявку')" size=l class="w-100" />
            </div>
          </form>
        </div>
      </div>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
import bimButton from "@bimlib/components/bimButton"
import bimInput from "@bimlib/components/bimInput"
import bimTextarea from "@bimlib/components/bimTextarea"
import { logDownloadPluginBIMLIBCAD } from "@/utils/logEvents"
export default {
  name: "BlockActionTime",
  components: {
    bimContainer,
    bimCol,
    bimButton,
    bimInput,
    bimTextarea
  },
  data() {
    return {
      sending: false,
      form: {
        name: "",
        phone: "",
        desc: ""
      }
    }
  },
  computed: {
    formValidation() {
      return {
        "form.name": ["required"],
        "form.phone": ["required", "phone"],
        "form.desc": []
      }
    }
  },
  methods: {
    logDownloadPluginBIMLIBCAD,
    sendForm() {
      if (!this.form.name.length || !this.form.phone.length) return
      this.sending = true 

      const data = new FormData()
      
      data.append('first_name', this.form.name)
      data.append('phone', this.form.phone)
      if (this.form.desc) {
        data.append('servicesArray', JSON.stringify([{ name: `Суть обращения: ${this.form.desc}` }]))
      }

      axios
        .post('/?m=Statics&a=form_request', data)
        .then(response => {
          if (response.data.success) {
            this.form.desc = ""
            this.form.phone = ""
            this.form.name = ""

            this.$toast(this.$t('Запрос успешно отправлен!'))

          } else {
            this.$toast(this.$t('Что-то пошло не так, попробуйте снова'), {title: this.$t('Ошибка')})
          }
        })
        .catch(e => {
          console.error(e)
        })
        .finally(( ) => this.sending = false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/grid-settings";
@import "./src/front_white/sass/components/color";

.action-container {
  width: 100%;
  background-color: $white-color;
}

.text-center {
  text-align: center;
}

.action-time {
  padding: 84px 0 66px;

  .action-time__title {
    line-height: 1.08;
    padding-bottom: 32px;

    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 24px;
      }
    }
  }

  .action-time__button-download {
    font-size: 18px;
    padding: 21px 60px;
    height: auto;
  }

  .action-time__text {
    line-height: 1.42;
    width: 60%;

    @media screen and (max-width: $breakpoint-sm) {
      width: 100%;
      font-size: 18px;
    }
  }

  .action-time__form {
    border-radius: 5px;
    border: solid 1.5px $white-color-300;
    background-color: $white-color;
  }
}

.block-form {

  .block-form__wrapper {
    width: 685px;
  }
  
  .block-form__textarea ::v-deep textarea {
    width: 100% !important;
    height: 91px !important;
  }

  @media screen and (max-width: $breakpoint-md) {
    width: 100%;
    
    .block-form__wrapper {
      width: 100%;
    }
  }
}
</style>
